<template>
  <b-container>
    <b-row class="justify-content-md-center">
      <b-col cols="12" md="7" class="text-center">
        <h2 class="mb-4">{{ $t("verification.unverifiedSignIn.h") }}</h2>
        <email-verification :email="email"></email-verification>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
// @ is an alias to /src
import EmailVerification from "@/components/sign-up/EmailVerification";

export default {
  name: "EmailConfirmationRequired",
  components: { EmailVerification },
  props: {
    email: {
      type: Object,
      required: null,
    },
  },
};
</script>

<style scoped>
</style>